// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__9V7Q-","accent":"Badge_accent__V+qaI","secondary":"Badge_secondary__hQ39n","neutral":"Badge_neutral__efyFh"};